/**
 * @param {Array} mainItems - site.menu items (main nav)
 * @param {Array} auxiliaryItems - auxiliary menu items
 * @param {Array<{title: string, to: 'main' | 'auxiliary', position?: number}>} moves
 *   position is 0-based index in the target menu. Omit to append at the end.
 */
export function arrangeNav(mainItems, auxiliaryItems, moves = []) {
  if (!moves.length) return { main: mainItems, auxiliary: auxiliaryItems }

  const moveMap = new Map(moves.map((m) => [m.title.toLowerCase(), m]))

  const main = []
  const auxiliary = []
  const movedToMain = []
  const movedToAuxiliary = []

  for (const item of mainItems) {
    const move = moveMap.get(item.title.toLowerCase())
    if (move && move.to === 'auxiliary') {
      movedToAuxiliary.push({ item: { ...item, _gbMoved: true }, position: move.position })
    } else {
      main.push(item)
    }
  }

  for (const item of auxiliaryItems) {
    const move = moveMap.get(item.title.toLowerCase())
    if (move && move.to === 'main') {
      movedToMain.push({ item: { ...item, _gbMoved: true }, position: move.position })
    } else {
      auxiliary.push(item)
    }
  }

  for (const { item, position } of movedToMain) {
    if (position != null && position <= main.length) {
      main.splice(position, 0, item)
    } else {
      main.push(item)
    }
  }

  for (const { item, position } of movedToAuxiliary) {
    if (position != null && position <= auxiliary.length) {
      auxiliary.splice(position, 0, item)
    } else {
      auxiliary.push(item)
    }
  }

  return { main, auxiliary }
}
